import { dropCursorExtension as dropCursorExtensionBase } from '@copera/tiptap/extensions';

export const dropCursorExtension = dropCursorExtensionBase.configure({
  width: 4,
  color: 'var(--theme-color-stone-30004)',
});
